export default __webpack_public_path__ + "3294fe70d588c9457a61dbc882acdf77.png";